export const APPROVAL_UNAVAILABLE_MSG =
  'There are no days in this request remaining to be processed. Days in this request have been approved on previously processed requests.';

export const OVERRIDE_NOT_AVAILABLE_MSG =
  'Override to Approved not available due to existing Full or 3 Partial day requests.';

export const FULL_APPROVAL_UNAVAILABLE_MSG =
  'This request can only be partially approved as it includes calendar day(s) that have been approved in another Vacation Bidding request(s).';

export const HOLD_RELEASE_NORMAL_MSG =
  'Cannot Hold Request: Start date is less than 15 days';

export const HOLD_RELEASE_VB_MSG =
  'Cannot Hold Request: Start date is less than 1 day';

export const FPD_MSG =
  'Remember, per the National Agreement Requests for a single Personal day off, or for hours within a single shift, shall be granted upon receipt of at least 2 weeks notice.';